import size from "lodash/size";
import CommentItemRenderer from "../../../_src_shared/comments/CommentItemRenderer";
import SideCardModal from "../../modals/SideCardModal";
import LoanCommentTextBox from "./LoanCommentTextBox";

const LoanCommentsSideCardPreview = ({ show, onClose, loan, comments }) => {
  return (
    <SideCardModal
      title={`Loan Comments (${size(comments)})`}
      show={show}
      onClose={onClose}
      suppressBodyPadding
      bodySx={{ pt: 1.5, position: "relative" }}
    >
      <LoanCommentTextBox loan={loan} sx={{ px: 2 }} />
      <CommentItemRenderer px={2} comments={comments} />
    </SideCardModal>
  );
};

export default LoanCommentsSideCardPreview;
